import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShoppingBag } from 'lucide-react';
import { ECOMMERCE_FORM_PATH, SECONDARY_CTA_CLASS } from './ctaStyles';
import { OfferFormCta } from './OfferCtaButtons';

const OfferEcommerce: React.FC = () => (
  <section id="web-ecommerce" className="py-12 bg-canvas border-t border-line">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="rounded-xl border border-line bg-white/5 p-6 flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.5, ease: 'easeOut' }}
      >
        <div className="flex flex-col md:flex-row items-center gap-4">
          <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg border border-line-strong bg-white/10 text-accent-soft">
            <ShoppingBag className="h-6 w-6" />
          </div>
          <div>
            <h2 className="text-balance text-fg font-semibold text-lg mb-1">Besoin d'une boutique en ligne ?</h2>
            <p className="text-fg-muted text-sm">Hors forfait, sur devis personnalisé.</p>
          </div>
        </div>
        <OfferFormCta
          location="ecommerce"
          to={ECOMMERCE_FORM_PATH}
          label="Demander un devis e-commerce"
          icon={ArrowRight}
          dataTrack="devis"
          className={`${SECONDARY_CTA_CLASS} whitespace-nowrap`}
        />
      </motion.div>
    </div>
  </section>
);

export default OfferEcommerce;
